import { styled } from '@stitches/configed';
import {
  Pagination as AntdPagination,
  PaginationProps,
  Select,
  Space,
} from 'antd';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { usePagination } from './usePagination';
import { createPageURL } from './utils';

const pageSizeOptions = [10, 20, 50, 100].map((x) => ({
  label: x,
  value: x,
}));
export const Pagination = (props: PaginationProps) => {
  const { page: current, pageSize } = usePagination();
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <PaginationStyled>
      <Space>
        <span>Hiển thị</span>
        <Select
          value={pageSize}
          options={pageSizeOptions}
          onChange={(value) => {
            searchParams.set('pageSize', value.toString());
            setSearchParams(searchParams);
          }}
        />
      </Space>
      <AntdPagination
        current={current}
        pageSize={pageSize}
        showTotal={(total) => `Tổng cộng ${total} kết quả`}
        itemRender={(page, type, element) =>
          type === 'page' ? (
            <Link to={createPageURL(page, pathname, searchParams)}>{page}</Link>
          ) : (
            element
          )
        }
        {...props}
      />
    </PaginationStyled>
  );
};

const PaginationStyled = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
